import { DataProductListingFilterDefinition as DataProductListingFilterDefinitionProto , DataListingColumn } from "@unacast-internal/unacat-ts/gen/unacast/catalog/v1/data_product_listing_pb"
import { Dataset, DatasetWithAccess } from "./dataset"
import { ExtractFields } from "./extractFields"
import { FieldDefinition } from "@unacast-internal/unacat-ts/gen/unacast/catalog/v3/query_pb"

export type FilterSpec = {
  item: DataProductListingFilterDefinition
  field: ExtractFields<FieldDefinition>
}

export type DataProductListingFilterDefinition = ExtractFields<DataProductListingFilterDefinitionProto>

export function mapAvailableFilters(
  highlightedFilters: DataProductListingFilterDefinition[],
  dataset: DatasetWithAccess,
): FilterSpec[] {
  return highlightedFilters
    .map((item) => {
      const field = dataset.dataref.fields
        .filter((f) => f.sourceColumn.split(".")[1] === item.ref)
        .sort((a, b) =>
          b.sourceColumn
            .split(".")[2]
            .localeCompare(a.sourceColumn.split(".")[2]),
        )
        .pop()
      return {
        item,
        field,
      }
    })
    .filter((f): f is FilterSpec => f.field !== undefined)
}
